import { createSelector } from 'reselect';
import { combineRestaurantsData } from '../components/common/DataGrid/filters/helper';

const getRestaurants = state => state.businessApp.restaurants;
const getPosSuppliers = state => state.meta.posSuppliers;

export const getFullRestaurantsData = createSelector(
    [getRestaurants, getPosSuppliers],
    combineRestaurantsData
);

